let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7rE1n")).then(() => parcelRequire('dkj8B'));